import { default as aboutbGRVkJMC52Meta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsF5lDg44LB0Meta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93f4N3s0pcMWMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleIv1eh6nP0tMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsHtx3Ey3EZqMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93wujv1ncT9HMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewpHU1IUqMWxMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexI4Md41zkQDMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_937ZiwtRyU6XMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexm4666qsJJPMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93C5RBtyeDUmMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexD0JaF1WbvyMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsgSL2K720MwMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsi9kpU2iEMfMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsSOw2WzoVtxMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93A5KdwltQYgMeta } from "/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexzQESacrqGjMeta } from "/tmp/build_3e045d40/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmMep9Vo4JQ1Meta } from "/tmp/build_3e045d40/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmYVKhOz0mk0Meta } from "/tmp/build_3e045d40/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendar8Nggq64rkqMeta } from "/tmp/build_3e045d40/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatRnemcMUuwSMeta } from "/tmp/build_3e045d40/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutHxgw37uEAMMeta } from "/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedgHlny362u3Meta } from "/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as memberssCrG1jMmS8Meta } from "/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93tRorz0nipCMeta } from "/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editALR4V6TfmTMeta } from "/tmp/build_3e045d40/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93LBW4o5waaoMeta } from "/tmp/build_3e045d40/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityioZg22uSk1Meta } from "/tmp/build_3e045d40/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93FwAq2vQgxaMeta } from "/tmp/build_3e045d40/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_9310JTuOGEGQMeta } from "/tmp/build_3e045d40/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboard9M5KqNEPLYMeta } from "/tmp/build_3e045d40/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexTo1AtQpt1BMeta } from "/tmp/build_3e045d40/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutOfVyj3HBuKMeta } from "/tmp/build_3e045d40/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45product0QIwiTYugeMeta } from "/tmp/build_3e045d40/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsbKIU78OdrPMeta } from "/tmp/build_3e045d40/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_934elg4IKLBCMeta } from "/tmp/build_3e045d40/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexlcHkBm5Bx3Meta } from "/tmp/build_3e045d40/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93mVWa4whqKMMeta } from "/tmp/build_3e045d40/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_938nxIGxixBdMeta } from "/tmp/build_3e045d40/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexhRbDeci9QSMeta } from "/tmp/build_3e045d40/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_930CO0Ov7kBfMeta } from "/tmp/build_3e045d40/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinToI4rynWpLMeta } from "/tmp/build_3e045d40/pages/[studio_url]/join.vue?macro=true";
import { default as loginLZfiMt7ABjMeta } from "/tmp/build_3e045d40/pages/[studio_url]/login.vue?macro=true";
import { default as logoutzEltSrDWPaMeta } from "/tmp/build_3e045d40/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_930AhVL4TGxMMeta } from "/tmp/build_3e045d40/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93Q9isItCQNpMeta } from "/tmp/build_3e045d40/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93IV8AuGq3MjMeta } from "/tmp/build_3e045d40/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesAG6EN2SEoQMeta } from "/tmp/build_3e045d40/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosW4D2fVHYEwMeta } from "/tmp/build_3e045d40/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optin0Hx2WB860sMeta } from "/tmp/build_3e045d40/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93nYZITBZ0g3Meta } from "/tmp/build_3e045d40/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexchr1dEyKcpMeta } from "/tmp/build_3e045d40/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexzvqfQyI9WCMeta } from "/tmp/build_3e045d40/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as about4qiRLllVIGMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentZ9ln9kOMflMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as events4AXZVevA4YMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93Jh6bB5bJnxMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleWI3KwRzzjpMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsCbxUSdYz65Meta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93QmPiyRKTalMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as view87iPFQC5kAMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexVWnQ0mMzduMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93FdWYEtWD04Meta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as index9zVB6mew7LMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93Da4yVEI6DnMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexgu1q0Ox0LVMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsJJx7HZQoPyMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsft7MW3g94AMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviews4RpKAsBMEXMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93SxD7xM66HPMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexbaAcK19xLrMeta } from "/tmp/build_3e045d40/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexYsZdWy1Y3LMeta } from "/tmp/build_3e045d40/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesMmxsiCV7DrMeta } from "/tmp/build_3e045d40/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsrUeGs882NwMeta } from "/tmp/build_3e045d40/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93Bz1iLZbTmSMeta } from "/tmp/build_3e045d40/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93ppDNH7CtZKMeta } from "/tmp/build_3e045d40/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as reset7kHxtNR1x6Meta } from "/tmp/build_3e045d40/pages/[studio_url]/reset.vue?macro=true";
import { default as shopJ4ZBTLazIBMeta } from "/tmp/build_3e045d40/pages/[studio_url]/shop.vue?macro=true";
import { default as signupi8Pf7g9i6rMeta } from "/tmp/build_3e045d40/pages/[studio_url]/signup.vue?macro=true";
import { default as liveuQuJFRHZc9Meta } from "/tmp/build_3e045d40/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipshfiorIXO33Meta } from "/tmp/build_3e045d40/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93xQQY2PtyBQMeta } from "/tmp/build_3e045d40/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactcb8Alvp1akMeta } from "/tmp/build_3e045d40/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullNRZvxt8TVSMeta } from "/tmp/build_3e045d40/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93A5KdwltQYgMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93A5KdwltQYgMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93A5KdwltQYgMeta || {},
    alias: _91product_id_93A5KdwltQYgMeta?.alias || [],
    redirect: _91product_id_93A5KdwltQYgMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutbGRVkJMC52Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutbGRVkJMC52Meta?.path ?? "about",
    meta: aboutbGRVkJMC52Meta || {},
    alias: aboutbGRVkJMC52Meta?.alias || [],
    redirect: aboutbGRVkJMC52Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsF5lDg44LB0Meta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsF5lDg44LB0Meta?.path ?? "events",
    meta: eventsF5lDg44LB0Meta || {},
    alias: eventsF5lDg44LB0Meta?.alias || [],
    redirect: eventsF5lDg44LB0Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93f4N3s0pcMWMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93f4N3s0pcMWMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93f4N3s0pcMWMeta || {},
    alias: _91media_id_93f4N3s0pcMWMeta?.alias || [],
    redirect: _91media_id_93f4N3s0pcMWMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleIv1eh6nP0tMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleIv1eh6nP0tMeta?.path ?? "free-sample",
    meta: free_45sampleIv1eh6nP0tMeta || {},
    alias: free_45sampleIv1eh6nP0tMeta?.alias || [],
    redirect: free_45sampleIv1eh6nP0tMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsHtx3Ey3EZqMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsHtx3Ey3EZqMeta?.path ?? "included-products",
    meta: included_45productsHtx3Ey3EZqMeta || {},
    alias: included_45productsHtx3Ey3EZqMeta?.alias || [],
    redirect: included_45productsHtx3Ey3EZqMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93wujv1ncT9HMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93wujv1ncT9HMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93wujv1ncT9HMeta || {},
    alias: _91media_id_93wujv1ncT9HMeta?.alias || [],
    redirect: _91media_id_93wujv1ncT9HMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewpHU1IUqMWxMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewpHU1IUqMWxMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewpHU1IUqMWxMeta || {},
    alias: viewpHU1IUqMWxMeta?.alias || [],
    redirect: viewpHU1IUqMWxMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexI4Md41zkQDMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexI4Md41zkQDMeta?.path ?? "lessons",
    meta: indexI4Md41zkQDMeta || {},
    alias: indexI4Md41zkQDMeta?.alias || [],
    redirect: indexI4Md41zkQDMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_937ZiwtRyU6XMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_937ZiwtRyU6XMeta?.path ?? "media/:media_id()",
    meta: _91media_id_937ZiwtRyU6XMeta || {},
    alias: _91media_id_937ZiwtRyU6XMeta?.alias || [],
    redirect: _91media_id_937ZiwtRyU6XMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexm4666qsJJPMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexm4666qsJJPMeta?.path ?? "playlists/:playlist_id()",
    meta: indexm4666qsJJPMeta || {},
    alias: indexm4666qsJJPMeta?.alias || [],
    redirect: indexm4666qsJJPMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93C5RBtyeDUmMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93C5RBtyeDUmMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93C5RBtyeDUmMeta || {},
    alias: _91media_id_93C5RBtyeDUmMeta?.alias || [],
    redirect: _91media_id_93C5RBtyeDUmMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexD0JaF1WbvyMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexD0JaF1WbvyMeta?.path ?? "playlists",
    meta: indexD0JaF1WbvyMeta || {},
    alias: indexD0JaF1WbvyMeta?.alias || [],
    redirect: indexD0JaF1WbvyMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsgSL2K720MwMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsgSL2K720MwMeta?.path ?? "private-sessions",
    meta: private_45sessionsgSL2K720MwMeta || {},
    alias: private_45sessionsgSL2K720MwMeta?.alias || [],
    redirect: private_45sessionsgSL2K720MwMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsi9kpU2iEMfMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsi9kpU2iEMfMeta?.path ?? "recordings",
    meta: recordingsi9kpU2iEMfMeta || {},
    alias: recordingsi9kpU2iEMfMeta?.alias || [],
    redirect: recordingsi9kpU2iEMfMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsSOw2WzoVtxMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsSOw2WzoVtxMeta?.path ?? "reviews",
    meta: reviewsSOw2WzoVtxMeta || {},
    alias: reviewsSOw2WzoVtxMeta?.alias || [],
    redirect: reviewsSOw2WzoVtxMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexzQESacrqGjMeta?.name ?? "buy-product-product_id",
    path: indexzQESacrqGjMeta?.path ?? "/buy/product/:product_id()",
    meta: indexzQESacrqGjMeta || {},
    alias: indexzQESacrqGjMeta?.alias || [],
    redirect: indexzQESacrqGjMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmMep9Vo4JQ1Meta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmMep9Vo4JQ1Meta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmMep9Vo4JQ1Meta || {},
    alias: confirmMep9Vo4JQ1Meta?.alias || [],
    redirect: confirmMep9Vo4JQ1Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmYVKhOz0mk0Meta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmYVKhOz0mk0Meta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmYVKhOz0mk0Meta || {},
    alias: confirmYVKhOz0mk0Meta?.alias || [],
    redirect: confirmYVKhOz0mk0Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendar8Nggq64rkqMeta?.name ?? "calendar",
    path: calendar8Nggq64rkqMeta?.path ?? "/calendar",
    meta: calendar8Nggq64rkqMeta || {},
    alias: calendar8Nggq64rkqMeta?.alias || [],
    redirect: calendar8Nggq64rkqMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatRnemcMUuwSMeta?.name ?? "chat",
    path: chatRnemcMUuwSMeta?.path ?? "/chat",
    meta: chatRnemcMUuwSMeta || {},
    alias: chatRnemcMUuwSMeta?.alias || [],
    redirect: chatRnemcMUuwSMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93tRorz0nipCMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93tRorz0nipCMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93tRorz0nipCMeta || {},
    alias: _91group_id_93tRorz0nipCMeta?.alias || [],
    redirect: _91group_id_93tRorz0nipCMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutHxgw37uEAMMeta?.name ?? "community-groups-group_id-about",
    path: aboutHxgw37uEAMMeta?.path ?? "about",
    meta: aboutHxgw37uEAMMeta || {},
    alias: aboutHxgw37uEAMMeta?.alias || [],
    redirect: aboutHxgw37uEAMMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedgHlny362u3Meta?.name ?? "community-groups-group_id-feed",
    path: feedgHlny362u3Meta?.path ?? "feed",
    meta: feedgHlny362u3Meta || {},
    alias: feedgHlny362u3Meta?.alias || [],
    redirect: feedgHlny362u3Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: memberssCrG1jMmS8Meta?.name ?? "community-groups-group_id-members",
    path: memberssCrG1jMmS8Meta?.path ?? "members",
    meta: memberssCrG1jMmS8Meta || {},
    alias: memberssCrG1jMmS8Meta?.alias || [],
    redirect: memberssCrG1jMmS8Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editALR4V6TfmTMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editALR4V6TfmTMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editALR4V6TfmTMeta || {},
    alias: community_45profile_45editALR4V6TfmTMeta?.alias || [],
    redirect: community_45profile_45editALR4V6TfmTMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93LBW4o5waaoMeta?.name ?? "community-profile-id",
    path: _91id_93LBW4o5waaoMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93LBW4o5waaoMeta || {},
    alias: _91id_93LBW4o5waaoMeta?.alias || [],
    redirect: _91id_93LBW4o5waaoMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityioZg22uSk1Meta?.name ?? "community",
    path: communityioZg22uSk1Meta?.path ?? "/community",
    meta: communityioZg22uSk1Meta || {},
    alias: communityioZg22uSk1Meta?.alias || [],
    redirect: communityioZg22uSk1Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93FwAq2vQgxaMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93FwAq2vQgxaMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93FwAq2vQgxaMeta || {},
    alias: _91uuid_93FwAq2vQgxaMeta?.alias || [],
    redirect: _91uuid_93FwAq2vQgxaMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_9310JTuOGEGQMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_9310JTuOGEGQMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_9310JTuOGEGQMeta || {},
    alias: _91unique_id_9310JTuOGEGQMeta?.alias || [],
    redirect: _91unique_id_9310JTuOGEGQMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboard9M5KqNEPLYMeta?.name ?? "dashboard",
    path: dashboard9M5KqNEPLYMeta?.path ?? "/dashboard",
    meta: dashboard9M5KqNEPLYMeta || {},
    alias: dashboard9M5KqNEPLYMeta?.alias || [],
    redirect: dashboard9M5KqNEPLYMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexTo1AtQpt1BMeta?.name ?? "event-details-event_id",
    path: indexTo1AtQpt1BMeta?.path ?? "/event/details/:event_id()",
    meta: indexTo1AtQpt1BMeta || {},
    alias: indexTo1AtQpt1BMeta?.alias || [],
    redirect: indexTo1AtQpt1BMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutOfVyj3HBuKMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutOfVyj3HBuKMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutOfVyj3HBuKMeta || {},
    alias: checkoutOfVyj3HBuKMeta?.alias || [],
    redirect: checkoutOfVyj3HBuKMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45product0QIwiTYugeMeta?.name ?? "event-details-event_id-select-product",
    path: select_45product0QIwiTYugeMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45product0QIwiTYugeMeta || {},
    alias: select_45product0QIwiTYugeMeta?.alias || [],
    redirect: select_45product0QIwiTYugeMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsbKIU78OdrPMeta?.name ?? "events",
    path: eventsbKIU78OdrPMeta?.path ?? "/events",
    meta: eventsbKIU78OdrPMeta || {},
    alias: eventsbKIU78OdrPMeta?.alias || [],
    redirect: eventsbKIU78OdrPMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_934elg4IKLBCMeta?.name ?? "gifts-uuid",
    path: _91uuid_934elg4IKLBCMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_934elg4IKLBCMeta || {},
    alias: _91uuid_934elg4IKLBCMeta?.alias || [],
    redirect: _91uuid_934elg4IKLBCMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexlcHkBm5Bx3Meta?.name ?? "gifts",
    path: indexlcHkBm5Bx3Meta?.path ?? "/gifts",
    meta: indexlcHkBm5Bx3Meta || {},
    alias: indexlcHkBm5Bx3Meta?.alias || [],
    redirect: indexlcHkBm5Bx3Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93mVWa4whqKMMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93mVWa4whqKMMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93mVWa4whqKMMeta || {},
    alias: _91invitation_id_93mVWa4whqKMMeta?.alias || [],
    redirect: _91invitation_id_93mVWa4whqKMMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_938nxIGxixBdMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_938nxIGxixBdMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_938nxIGxixBdMeta || {},
    alias: _91product_id_938nxIGxixBdMeta?.alias || [],
    redirect: _91product_id_938nxIGxixBdMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexhRbDeci9QSMeta?.name ?? "index",
    path: indexhRbDeci9QSMeta?.path ?? "/",
    meta: indexhRbDeci9QSMeta || {},
    alias: indexhRbDeci9QSMeta?.alias || [],
    redirect: indexhRbDeci9QSMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_930CO0Ov7kBfMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_930CO0Ov7kBfMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_930CO0Ov7kBfMeta || {},
    alias: _91invitation_unique_id_930CO0Ov7kBfMeta?.alias || [],
    redirect: _91invitation_unique_id_930CO0Ov7kBfMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinToI4rynWpLMeta?.name ?? "join",
    path: joinToI4rynWpLMeta?.path ?? "/join",
    meta: joinToI4rynWpLMeta || {},
    alias: joinToI4rynWpLMeta?.alias || [],
    redirect: joinToI4rynWpLMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginLZfiMt7ABjMeta?.name ?? "login",
    path: loginLZfiMt7ABjMeta?.path ?? "/login",
    meta: loginLZfiMt7ABjMeta || {},
    alias: loginLZfiMt7ABjMeta?.alias || [],
    redirect: loginLZfiMt7ABjMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutzEltSrDWPaMeta?.name ?? "logout",
    path: logoutzEltSrDWPaMeta?.path ?? "/logout",
    meta: logoutzEltSrDWPaMeta || {},
    alias: logoutzEltSrDWPaMeta?.alias || [],
    redirect: logoutzEltSrDWPaMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_930AhVL4TGxMMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_930AhVL4TGxMMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_930AhVL4TGxMMeta || {},
    alias: _91meeting_type_slug_930AhVL4TGxMMeta?.alias || [],
    redirect: _91meeting_type_slug_930AhVL4TGxMMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93Q9isItCQNpMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93Q9isItCQNpMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93Q9isItCQNpMeta || {},
    alias: _91meeting_unique_id_93Q9isItCQNpMeta?.alias || [],
    redirect: _91meeting_unique_id_93Q9isItCQNpMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93IV8AuGq3MjMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93IV8AuGq3MjMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93IV8AuGq3MjMeta || {},
    alias: _91meeting_unique_id_93IV8AuGq3MjMeta?.alias || [],
    redirect: _91meeting_unique_id_93IV8AuGq3MjMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesAG6EN2SEoQMeta?.name ?? "my-favorites",
    path: my_45favoritesAG6EN2SEoQMeta?.path ?? "/my-favorites",
    meta: my_45favoritesAG6EN2SEoQMeta || {},
    alias: my_45favoritesAG6EN2SEoQMeta?.alias || [],
    redirect: my_45favoritesAG6EN2SEoQMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosW4D2fVHYEwMeta?.name ?? "my-studios",
    path: my_45studiosW4D2fVHYEwMeta?.path ?? "/my-studios",
    meta: my_45studiosW4D2fVHYEwMeta || {},
    alias: my_45studiosW4D2fVHYEwMeta?.alias || [],
    redirect: my_45studiosW4D2fVHYEwMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optin0Hx2WB860sMeta?.name ?? "optin",
    path: optin0Hx2WB860sMeta?.path ?? "/optin",
    meta: optin0Hx2WB860sMeta || {},
    alias: optin0Hx2WB860sMeta?.alias || [],
    redirect: optin0Hx2WB860sMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93nYZITBZ0g3Meta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93nYZITBZ0g3Meta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93nYZITBZ0g3Meta || {},
    alias: _91episode_id_93nYZITBZ0g3Meta?.alias || [],
    redirect: _91episode_id_93nYZITBZ0g3Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexchr1dEyKcpMeta?.name ?? "podcasts-podcast_id",
    path: indexchr1dEyKcpMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexchr1dEyKcpMeta || {},
    alias: indexchr1dEyKcpMeta?.alias || [],
    redirect: indexchr1dEyKcpMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexzvqfQyI9WCMeta?.name ?? "podcasts",
    path: indexzvqfQyI9WCMeta?.path ?? "/podcasts",
    meta: indexzvqfQyI9WCMeta || {},
    alias: indexzvqfQyI9WCMeta?.alias || [],
    redirect: indexzvqfQyI9WCMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93SxD7xM66HPMeta?.name ?? "product-product_id",
    path: _91product_id_93SxD7xM66HPMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93SxD7xM66HPMeta || {},
    alias: _91product_id_93SxD7xM66HPMeta?.alias || [],
    redirect: _91product_id_93SxD7xM66HPMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: about4qiRLllVIGMeta?.name ?? "product-product_id-about",
    path: about4qiRLllVIGMeta?.path ?? "about",
    meta: about4qiRLllVIGMeta || {},
    alias: about4qiRLllVIGMeta?.alias || [],
    redirect: about4qiRLllVIGMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentZ9ln9kOMflMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentZ9ln9kOMflMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentZ9ln9kOMflMeta || {},
    alias: digital_45download_45contentZ9ln9kOMflMeta?.alias || [],
    redirect: digital_45download_45contentZ9ln9kOMflMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: events4AXZVevA4YMeta?.name ?? "product-product_id-events",
    path: events4AXZVevA4YMeta?.path ?? "events",
    meta: events4AXZVevA4YMeta || {},
    alias: events4AXZVevA4YMeta?.alias || [],
    redirect: events4AXZVevA4YMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Jh6bB5bJnxMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93Jh6bB5bJnxMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93Jh6bB5bJnxMeta || {},
    alias: _91media_id_93Jh6bB5bJnxMeta?.alias || [],
    redirect: _91media_id_93Jh6bB5bJnxMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleWI3KwRzzjpMeta?.name ?? "product-product_id-free-sample",
    path: free_45sampleWI3KwRzzjpMeta?.path ?? "free-sample",
    meta: free_45sampleWI3KwRzzjpMeta || {},
    alias: free_45sampleWI3KwRzzjpMeta?.alias || [],
    redirect: free_45sampleWI3KwRzzjpMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsCbxUSdYz65Meta?.name ?? "product-product_id-included-products",
    path: included_45productsCbxUSdYz65Meta?.path ?? "included-products",
    meta: included_45productsCbxUSdYz65Meta || {},
    alias: included_45productsCbxUSdYz65Meta?.alias || [],
    redirect: included_45productsCbxUSdYz65Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93QmPiyRKTalMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93QmPiyRKTalMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93QmPiyRKTalMeta || {},
    alias: _91media_id_93QmPiyRKTalMeta?.alias || [],
    redirect: _91media_id_93QmPiyRKTalMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: view87iPFQC5kAMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: view87iPFQC5kAMeta?.path ?? "lessons/:lesson_id()/view",
    meta: view87iPFQC5kAMeta || {},
    alias: view87iPFQC5kAMeta?.alias || [],
    redirect: view87iPFQC5kAMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexVWnQ0mMzduMeta?.name ?? "product-product_id-lessons",
    path: indexVWnQ0mMzduMeta?.path ?? "lessons",
    meta: indexVWnQ0mMzduMeta || {},
    alias: indexVWnQ0mMzduMeta?.alias || [],
    redirect: indexVWnQ0mMzduMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93FdWYEtWD04Meta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93FdWYEtWD04Meta?.path ?? "media/:media_id()",
    meta: _91media_id_93FdWYEtWD04Meta || {},
    alias: _91media_id_93FdWYEtWD04Meta?.alias || [],
    redirect: _91media_id_93FdWYEtWD04Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index9zVB6mew7LMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: index9zVB6mew7LMeta?.path ?? "playlists/:playlist_id()",
    meta: index9zVB6mew7LMeta || {},
    alias: index9zVB6mew7LMeta?.alias || [],
    redirect: index9zVB6mew7LMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Da4yVEI6DnMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93Da4yVEI6DnMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93Da4yVEI6DnMeta || {},
    alias: _91media_id_93Da4yVEI6DnMeta?.alias || [],
    redirect: _91media_id_93Da4yVEI6DnMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexgu1q0Ox0LVMeta?.name ?? "product-product_id-playlists",
    path: indexgu1q0Ox0LVMeta?.path ?? "playlists",
    meta: indexgu1q0Ox0LVMeta || {},
    alias: indexgu1q0Ox0LVMeta?.alias || [],
    redirect: indexgu1q0Ox0LVMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsJJx7HZQoPyMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsJJx7HZQoPyMeta?.path ?? "private-sessions",
    meta: private_45sessionsJJx7HZQoPyMeta || {},
    alias: private_45sessionsJJx7HZQoPyMeta?.alias || [],
    redirect: private_45sessionsJJx7HZQoPyMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsft7MW3g94AMeta?.name ?? "product-product_id-recordings",
    path: recordingsft7MW3g94AMeta?.path ?? "recordings",
    meta: recordingsft7MW3g94AMeta || {},
    alias: recordingsft7MW3g94AMeta?.alias || [],
    redirect: recordingsft7MW3g94AMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviews4RpKAsBMEXMeta?.name ?? "product-product_id-reviews",
    path: reviews4RpKAsBMEXMeta?.path ?? "reviews",
    meta: reviews4RpKAsBMEXMeta || {},
    alias: reviews4RpKAsBMEXMeta?.alias || [],
    redirect: reviews4RpKAsBMEXMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexbaAcK19xLrMeta?.name ?? "product",
    path: indexbaAcK19xLrMeta?.path ?? "/product",
    meta: indexbaAcK19xLrMeta || {},
    alias: indexbaAcK19xLrMeta?.alias || [],
    redirect: indexbaAcK19xLrMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexYsZdWy1Y3LMeta?.name ?? "profile",
    path: indexYsZdWy1Y3LMeta?.path ?? "/profile",
    meta: indexYsZdWy1Y3LMeta || {},
    alias: indexYsZdWy1Y3LMeta?.alias || [],
    redirect: indexYsZdWy1Y3LMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesMmxsiCV7DrMeta?.name ?? "profile-purchases",
    path: purchasesMmxsiCV7DrMeta?.path ?? "/profile/purchases",
    meta: purchasesMmxsiCV7DrMeta || {},
    alias: purchasesMmxsiCV7DrMeta?.alias || [],
    redirect: purchasesMmxsiCV7DrMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsrUeGs882NwMeta?.name ?? "profile-redemptions",
    path: redemptionsrUeGs882NwMeta?.path ?? "/profile/redemptions",
    meta: redemptionsrUeGs882NwMeta || {},
    alias: redemptionsrUeGs882NwMeta?.alias || [],
    redirect: redemptionsrUeGs882NwMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93Bz1iLZbTmSMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93Bz1iLZbTmSMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93Bz1iLZbTmSMeta || {},
    alias: _91quiz_id_93Bz1iLZbTmSMeta?.alias || [],
    redirect: _91quiz_id_93Bz1iLZbTmSMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93ppDNH7CtZKMeta?.name ?? "reset-password-uid-token",
    path: _91token_93ppDNH7CtZKMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93ppDNH7CtZKMeta || {},
    alias: _91token_93ppDNH7CtZKMeta?.alias || [],
    redirect: _91token_93ppDNH7CtZKMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: reset7kHxtNR1x6Meta?.name ?? "reset",
    path: reset7kHxtNR1x6Meta?.path ?? "/reset",
    meta: reset7kHxtNR1x6Meta || {},
    alias: reset7kHxtNR1x6Meta?.alias || [],
    redirect: reset7kHxtNR1x6Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopJ4ZBTLazIBMeta?.name ?? "shop",
    path: shopJ4ZBTLazIBMeta?.path ?? "/shop",
    meta: shopJ4ZBTLazIBMeta || {},
    alias: shopJ4ZBTLazIBMeta?.alias || [],
    redirect: shopJ4ZBTLazIBMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupi8Pf7g9i6rMeta?.name ?? "signup",
    path: signupi8Pf7g9i6rMeta?.path ?? "/signup",
    meta: signupi8Pf7g9i6rMeta || {},
    alias: signupi8Pf7g9i6rMeta?.alias || [],
    redirect: signupi8Pf7g9i6rMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveuQuJFRHZc9Meta?.name ?? "streaming-event_id-live",
    path: liveuQuJFRHZc9Meta?.path ?? "/streaming/:event_id()/live",
    meta: liveuQuJFRHZc9Meta || {},
    alias: liveuQuJFRHZc9Meta?.alias || [],
    redirect: liveuQuJFRHZc9Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipshfiorIXO33Meta?.name ?? "tips",
    path: tipshfiorIXO33Meta?.path ?? "/tips",
    meta: tipshfiorIXO33Meta || {},
    alias: tipshfiorIXO33Meta?.alias || [],
    redirect: tipshfiorIXO33Meta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93xQQY2PtyBQMeta?.name ?? "waiver-uuid",
    path: _91uuid_93xQQY2PtyBQMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93xQQY2PtyBQMeta || {},
    alias: _91uuid_93xQQY2PtyBQMeta?.alias || [],
    redirect: _91uuid_93xQQY2PtyBQMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactcb8Alvp1akMeta?.name ?? "widgets-calendars-compact",
    path: compactcb8Alvp1akMeta?.path ?? "/widgets/calendars/compact",
    meta: compactcb8Alvp1akMeta || {},
    alias: compactcb8Alvp1akMeta?.alias || [],
    redirect: compactcb8Alvp1akMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullNRZvxt8TVSMeta?.name ?? "widgets-calendars-full",
    path: fullNRZvxt8TVSMeta?.path ?? "/widgets/calendars/full",
    meta: fullNRZvxt8TVSMeta || {},
    alias: fullNRZvxt8TVSMeta?.alias || [],
    redirect: fullNRZvxt8TVSMeta?.redirect,
    component: () => import("/tmp/build_3e045d40/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]